import { createReducer, on } from '@ngrx/store';
import * as SourcesActions from '../actions/sources-actions';
import { iSourcesState, SourceData } from '@app/Shared/interfaces/iSources';

export const initialSourcesState: iSourcesState = {
    sources: [],
    selectedSource: null,
    isLoading: false,
    error: null,
};

export const sourcesReducer = createReducer(
    initialSourcesState,

    // Load Sources
    on(SourcesActions.loadSources, (state) => ({
        ...state,
        isLoading: true,
        error: null,
    })),

    on(SourcesActions.loadSourcesSuccess, (state, { sources }) => ({
        ...state,
        sources,
        isLoading: false,
        error: null,
    })),

    on(SourcesActions.loadSourcesFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error,
    })),

    // Create Source
    on(SourcesActions.createSource, (state) => ({
        ...state,
        isLoading: true,
        error: null,
    })),

    on(SourcesActions.createSourceSuccess, (state, { source }) => ({
        ...state,
        sources: [...state.sources, source],
        isLoading: false,
        error: null,
    })),

    on(SourcesActions.createSourceFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error,
    })),

    // Update Source
    on(SourcesActions.updateSource, (state) => ({
        ...state,
        isLoading: true,
        error: null,
    })),

    on(SourcesActions.updateSourceSuccess, (state, { source }) => ({
        ...state,
        sources: state.sources.map((s) => (s.sourceTruKey === source.sourceTruKey ? source : s)),
        selectedSource: state.selectedSource?.sourceTruKey === source.sourceTruKey ? source : state.selectedSource,
        isLoading: false,
        error: null,
    })),

    on(SourcesActions.updateSourceFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error,
    })),

    // Delete Source
    on(SourcesActions.deleteSource, (state) => ({
        ...state,
        isLoading: true,
        error: null,
    })),

    on(SourcesActions.deleteSourceSuccess, (state, { key }) => ({
        ...state,
        sources: state.sources.filter((s) => s.sourceTruKey !== key),
        selectedSource: state.selectedSource?.sourceTruKey === key ? null : state.selectedSource,
        isLoading: false,
        error: null,
    })),

    on(SourcesActions.deleteSourceFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error,
    })),

    // Select Source
    on(SourcesActions.selectSource, (state, { source }) => ({
        ...state,
        selectedSource: source,
    })),

    on(SourcesActions.clearSelectedSource, (state) => ({
        ...state,
        selectedSource: null,
    }))
);
